import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { nextTick } from '@studiometa/js-toolkit/utils';


/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Base<ComponentProps>}
 */
export default class Gallery extends withBreakpointObserver(Base) {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Gallery',
    refs: ['progress', 'progressBar'],
    options: {
      inactiveBreakpoints: {
          type: String,
          default: 'xxs xs s m',
      },
    },
  };

  mounted() {
    this.$refs.scrollContainer = this.$el.querySelector('.meta-gallery');
    this.scrolled();

    nextTick(() => {
      this.$refs.progress.classList.remove('tw-opacity-0', '-tw-translate-x-full');
    });
  }

  scrolled() {
    const containerRect = this.$refs.scrollContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const containerBottom = containerRect.bottom;
    const containerHeight = containerRect.height;
    
    const targetPosition = windowHeight / 2;
    const startPosition = windowHeight + containerHeight;
    const currentPosition = containerBottom;
    
    let progress = 0;
    if (currentPosition <= targetPosition) {
      progress = 100;
    } else if (currentPosition <= startPosition) {
      progress = ((startPosition - currentPosition) / (startPosition - targetPosition)) * 100;
    }

    const initialHeight = 24; // hauteur initiale en pixels
    const height = initialHeight + (progress * (100 - initialHeight) / 100);

    this.$refs.progressBar.style.height = `${height}%`;
  }
}
